import { ImageProviderBase } from "./ImageProviderBase";
var RequestEndpoint;
(function (RequestEndpoint) {
    RequestEndpoint["Image"] = "image";
    RequestEndpoint["Dispmap"] = "dispmap";
})(RequestEndpoint || (RequestEndpoint = {}));
export class Infra3DImageProvider extends ImageProviderBase {
    constructor(options, authObject) {
        super(options, authObject);
    }
    getAuthImageURL(url) {
        return `${ImageProviderBase.correct_url(this.host)}${RequestEndpoint.Image}/${url}&api_key=${this.authObject.apiKey}&access_token=${this.authObject.accessToken}`;
    }
    getAuthDispmapURL(url) {
        return `${ImageProviderBase.correct_url(this.host)}${RequestEndpoint.Dispmap}/${url}&api_key=${this.authObject.apiKey}&access_token=${this.authObject.accessToken}`;
    }
}
//# sourceMappingURL=Infra3DImageProvider.js.map